import { render, staticRenderFns } from "./Tuxhorn_Nemux_SML_V2_3d04.vue?vue&type=template&id=2c8e13cd&"
import script from "./Tuxhorn_Nemux_SML_V2_3d04.vue?vue&type=script&lang=js&"
export * from "./Tuxhorn_Nemux_SML_V2_3d04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports